/* eslint-disable no-console */
import * as integration from '../../../integration'
import * as commons from '../commons'
import * as types from './types'

const {
  actions: { receiveError }
} = commons

export const fetchCategories = () => ({
  type: types.FETCH_KNOWLEDGE_BASES_CATEGORY_LIST
})

export const fetchHighlights = ({ fetchMore }) => ({
  type: types.FETCH_KNOWLEDGE_BASES_HIGHLIGHTS_LIST,
  payload: { fetchMore }
})

export const fetchRecents = ({ fetchMore }) => ({
  type: types.FETCH_KNOWLEDGE_BASES_RECENTS_LIST,
  payload: { fetchMore }
})

export const fetchSelectedItem = () => ({
  type: types.FETCH_SELECTED_ITEM_KNOWLEDGE_BASES
})

export const receiveCategories = ({ res }) => ({
  type: types.RECEIVE_KNOWLEDGE_BASES_CATEGORY_LIST,
  payload: { res }
})

export const receiveHighlights = ({ res, fetchMore }) => ({
  type: types.RECEIVE_KNOWLEDGE_BASES_HIGHLIGHTS_LIST,
  payload: { res, fetchMore }
})

export const receiveRecents = ({ res, fetchMore }) => ({
  type: types.RECEIVE_KNOWLEDGE_BASES_RECENTS_LIST,
  payload: { res, fetchMore }
})

export const receiveSelectedItem = ({ data }) => ({
  type: types.RECEIVE_SELECTED_ITEM_KNOWLEDGE_BASES,
  payload: { data }
})

export const setFilters = (filters) => {
  return {
    type: types.SET_FILTERS_KNOWLEDGE_BASES,
    payload: { filters }
  }
}

export const setItem = ({ key, item }) => {
  return {
    type: types.SET_ITEM_KNOWLEDGE_BASES,
    payload: { key, item }
  }
}

export const getCategories = () => (dispatch) => {
  dispatch(fetchCategories())

  return integration.resources.knowledgeBases.requests
    .getCategories()
    .then((res) => {
      dispatch(receiveCategories({ res }))
    })
    .catch((err) => {
      dispatch(receiveError(err))
    })
}

export const getHighlights =
  ({ fetchMore } = {}) =>
  (dispatch, getState) => {
    const state = getState().knowledgeBaseReducer

    const nextPage = state.highlights.pagination.currentPage + 1

    if (fetchMore && nextPage > state.highlights.pagination.lastPage) {
      return null
    }

    dispatch(fetchHighlights({ fetchMore }))

    const params = {
      ...(state.filters.categoryId
        ? { category_id: state.filters.categoryId }
        : {}),
      ...(state.filters.title ? { title: state.filters.title } : {}),
      is_featured: '1',
      // per_page: 10,
      page: fetchMore ? nextPage : 1
    }

    return integration.resources.knowledgeBases.requests
      .getKnowledgeBases({ params })
      .then((res) => {
        dispatch(receiveHighlights({ res, fetchMore }))
      })
      .catch((err) => {
        dispatch(receiveError(err))
      })
  }

export const getRecents =
  ({ fetchMore, search } = {}) =>
  (dispatch, getState) => {
    const state = getState().knowledgeBaseReducer

    const nextPage = state.recents.pagination.currentPage + 1

    if (fetchMore && nextPage > state.recents.pagination.lastPage) {
      return null
    }

    dispatch(fetchRecents({ fetchMore }))

    const params = {
      ...(state.filters.categoryId
        ? { category_id: state.filters.categoryId }
        : {}),
      ...(state.filters.title ? { title: state.filters.title } : {}),
      is_featured: '0',
      per_page: 8,
      page: fetchMore ? nextPage : 1,
      title: search,
      search
    }

    return integration.resources.knowledgeBases.requests
      .getKnowledgeBases({ params })
      .then((res) => {
        dispatch(receiveRecents({ res, fetchMore }))
      })
      .catch((err) => {
        dispatch(receiveError(err))
      })
  }

export const getSelectedItem = (id) => (dispatch) => {
  dispatch(fetchSelectedItem())

  return integration.resources.knowledgeBases.requests
    .getById(id)
    .then((data) => {
      console.log('data------')
      console.log(data)
      dispatch(receiveSelectedItem({ data }))
      window.gtag('event', 'select_content', {
        content_type: 'knowledge bases',
        item_id: id
      })
    })
    .catch((err) => {
      console.log('err------')
      console.log(err)
      dispatch(receiveError(err))
    })
}

export const toggleFavorite =
  ({ key, item }) =>
  (dispatch) => {
    dispatch(setItem({ key, item: { ...item, loading: true } }))

    return integration.resources.knowledgeBases.requests
      .toggleFavorite(item)
      .then(() => {
        dispatch(
          setItem({
            key,
            item: { ...item, loading: false, isFavorite: !item.isFavorite }
          })
        )
      })
      .catch((err) => {
        dispatch(
          setItem({
            key,
            item: { ...item, loading: false }
          })
        )
        dispatch(receiveError(err))
      })
  }
